import saveAs from "file-saver";

export default defineNuxtPlugin(() => {
    return {
        provide: {
            saveBlob: (blob: Blob, headers: Headers) => {
                const contentDisposition = headers.get("Content-Disposition");
                const matches = contentDisposition ? contentDisposition.match(/filename=(.*);/) : null;
                const filename = Array.isArray(matches) ? matches[1] : undefined;
                saveAs(blob, filename);
            },
            saveAs,
        },
    };
});
